var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"value":_vm.cvalue,"suffix":_vm.suffix,"label":_vm.label,"filled":_vm.filled},on:{"focus":_vm.change,"blur":_vm.blur,"input":_vm.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }